export default {
    dateField: {
        type: String,
        default: undefined
    }, 
    navigator: {
        type: Object,
        default: undefined
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoStockChart/StockChartProps.js